export const environment = {
  sfAPI: 'https://services.wir.idp.com/api/v1/sf',
  getProgressiveProfileQuestionsApi: 'https://services.wir.idp.com/api/v1/getQuestions',
  isUserExistAPI: 'https://services.wir.idp.com/api/v1/student',
  postPPRegistration: 'https://services.wir.idp.com/api/v1/student',
  referenceDataValuesAPI: 'https://services.wir.idp.com/api/v1/referenceDataValues',
  // Azure AD Configuration - values injected from CI/CD pipeline variables
  azureAd: {
    tenantId: 'c0c7ad79-cf13-4f39-8eeb-a1829aa096a6',
    clientId: '655a1065-0352-4470-b462-9cb101e4d85c',
    authority: 'https://login.microsoftonline.com/c0c7ad79-cf13-4f39-8eeb-a1829aa096a6',
    redirectUri: 'https://wir.idp.com/redirect/',
    postLogoutRedirectUri: 'https://wir.idp.com/index.html',
    scopes: ['openid', 'profile', 'email']
  },
  gtmId: 'GTM-59SVWTM9',
  oneTrustDomainScript: '019e493d-d341-742c-9b02-da165053b916'
}
